import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CarteParametre } from './CarteParametre';

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')}` } });

// 🧾 Phase 4A : onglet « Paramètres » — une carte par clé, regroupées ; effet immédiat (aucun cache).
export function ParametresInstallateurs({ onChange }) {
  const [parametres, setParametres] = useState([]);
  const charger = useCallback(async () => {
    const r = await axios.get(`${API}/api/installateurs/parametres`, auth());
    setParametres(r.data.parametres || []);
  }, []);
  useEffect(() => { charger().catch(() => toast.error('Impossible de charger les paramètres.')); }, [charger]);

  const action = async (fn, succes) => {
    try { await fn(); toast.success(succes); await charger(); onChange?.(); return true; }
    catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || 'Erreur'); return false; }
  };
  const groupes = [...new Set(parametres.map((p) => p.groupe))];
  return (
    <div className="space-y-6" data-testid="onglet-parametres-contenu">
      <p className="text-xs text-slate-500" data-testid="parametres-aide">Toute valeur métier du chantier Installateurs se règle ici et s'applique immédiatement. Les taux légaux (TPS/TVQ) sont affichés
        en lecture seule : les changer rétroactivement fausserait l'historique des rapports.</p>
      {groupes.map((g) => (
        <section key={g} className="space-y-3" data-testid={`parametres-groupe-${g}`}>
          <h2 className="text-base font-semibold">{g}</h2>
          <div className="grid gap-3 md:grid-cols-2">
            {parametres.filter((p) => p.groupe === g).map((p) => (
              <CarteParametre key={p.cle} p={p}
                onEnregistrer={(cle, valeur) => action(() => axios.put(`${API}/api/installateurs/parametres/${cle}`, { valeur }, auth()), 'Paramètre enregistré')}
                onRetablir={(cle) => action(() => axios.post(`${API}/api/installateurs/parametres/${cle}/retablir`, {}, auth()), 'Valeur par défaut rétablie')}
                onSurcharge={(cle, annee, valeur) => action(() => axios.put(`${API}/api/installateurs/parametres/${cle}`, { valeur: valeur === null ? null : Number(valeur), annee }, auth()), valeur === null ? 'Surcharge retirée' : `Surcharge ${annee} enregistrée`)} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
